import React, { useState, useEffect } from "react";
import axios from "axios";
import Cookies from "js-cookie";
import { getBaseUrl } from "../../../service/apiUrl";
import Lottie from "lottie-react";
import Animate from "../../../assets/loader.json";
import { useTranslation } from "react-i18next";

const RecentActivitiesCard = () => {
  const { t } = useTranslation();
  const cookiedata = Cookies.get("i18next");
  const [activities, setActivities] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchActivities = async () => {
      try {
        const baseUrl = getBaseUrl();
        const response = await axios.get(`${baseUrl}/recent-results?limit=3`);
        if (response.data && response.data.success) {
          setActivities(response.data.data);
        }
      } catch (error) {
        console.error("Error fetching recent activities:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchActivities();
  }, []);

  // 3 Colors for the bottom border as requested
  const stripeColors = ["#68a34d", "#8e44ad", "#2980b9"];

  return (
    <div style={styles.mainContainer}>
      <h2 style={styles.headerTitle}>{t("RECENT ACTIVITIES")}</h2>
      
      <div style={styles.cardsWrapper}>
        {loading ? (
          <div style={{ display: "flex", justifyContent: "center", padding: "20px" }}>
            <Lottie animationData={Animate} loop={true} style={{ width: "100px" }} />
          </div>
        ) : activities.length > 0 ? (
          activities.map((activity, index) => (
          <div key={activity.id} style={styles.card}>
            <div style={styles.cardContent}>
              <h3 style={styles.locationText}>
                {cookiedata === "en" ? activity.locationEn : activity.locationAr}
              </h3>
              <p style={styles.dateText}>{activity.date}</p>

              {activity.races && activity.races.length > 0 && (
                <div style={styles.racesList}>
                  {activity.races.map((race) => (
                    <div key={race.id} style={styles.raceRow}>
                      <span style={styles.raceName}>
                        {cookiedata === "en" ? race.nameEn : race.nameAr}
                      </span>
                      <span style={styles.winnerName}>
                        {cookiedata === "en" ? race.winnerHorseNameEn : race.winnerHorseNameAr}
                      </span>
                    </div>
                  ))}
                </div>
              )}
            </div>
            {/* Bottom Color Stripe - rotating through 3 colors */}
            <div 
              style={{ 
                ...styles.bottomStripe, 
                backgroundColor: stripeColors[index % stripeColors.length] 
              }} 
            />
          </div>
          ))
        ) : (
          <p style={{ color: "#fff", textAlign: "center" }}>No recent activities</p>
        )}
      </div>
    </div>
  );
};

const styles = {
  mainContainer: {
    fontFamily: "'Segoe UI', Roboto, Helvetica, Arial, sans-serif",
    maxWidth: "800px",
    margin: "0 auto",
  },
  headerTitle: {
    color: "#0c0c0c",
    fontSize: "28px",
    fontWeight: "800",
    marginBottom: "20px",
    textTransform: "uppercase",
  },
  cardsWrapper: {
    display: "flex",
    flexDirection: "column",
    gap: "15px",
  },
  card: {
    backgroundColor: "#0d133a", 
    borderRadius: "20px",
    overflow: "hidden",
    display: "flex",
    flexDirection: "column",
    boxShadow: "0 4px 10px rgba(0,0,0,0.1)",
    cursor: "pointer",
    transition: "transform 0.2s ease",
  },
  cardContent: {
    padding: "20px 25px",
    color: "#ffffff",
  },
  locationText: {
    margin: "0",
    fontSize: "24px",
    fontWeight: "bold",
    letterSpacing: "0.5px",
  },
  dateText: {
    margin: "5px 0 0 0",
    fontSize: "18px",
    fontWeight: "400",
    opacity: "0.9",
  },
  bottomStripe: {
    height: "12px", 
    width: "100%",
  },
  racesList: {
    marginTop: "15px",
    display: "flex",
    flexDirection: "column",
    gap: "8px",
    borderTop: "1px solid rgba(255,255,255,0.1)",
    paddingTop: "10px",
  },
  raceRow: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  raceName: {
    fontSize: "14px",
    opacity: "0.8",
  },
  winnerName: {
    fontSize: "15px",
    fontWeight: "bold",
    color: "#ffffff",
  },
};

export default RecentActivitiesCard;